import { RouterProvider } from 'react-router-dom';
import { router } from '@/routes';
import { Toaster } from '@/components/ui/sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@/providers/ThemeProvider';
import { AuthProvider } from '@/contexts/AuthContext';
import { useEffect } from 'react';
import { setupDebugTools } from '@/utils/debugTools';
import { SessionTracking } from '@/components/common/SessionTracking';
import { PointerEventsGuard } from '@/components/common/PointerEventsGuard';

// Configure the query client with better defaults to prevent duplicate queries
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Add staleTime to prevent frequent refetching
      staleTime: 30000,
      // Add retry to prevent unnecessary retries
      retry: false,
      // Add refetchOnWindowFocus to prevent refetching when window gains focus
      refetchOnWindowFocus: false
    }
  }
});

function App() {
  // Initialize debug tools in development
  useEffect(() => {
    setupDebugTools();
  }, []);
  
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider defaultTheme="system" storageKey="ui-theme">
          <SessionTracking />
          <PointerEventsGuard />
          <RouterProvider router={router} />
          <Toaster />
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
